module.exports = __webpack_public_path__ + "fonts/fa-brands-400.5e2f9212.woff2";